var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useHover } from "../../hooks";
import useOutSideClick from "../../hooks/useOutSideClick";
import { isEmpty } from 'lodash';
import React, { useCallback, useRef, useState } from 'react';
import { css, styled } from "../../utils";
import AutoCompletions from "./AutoCompletions";
import Input, { InputProps } from "./Input";
var TAB_KEY = 9;
var AT_CHARACTER = '@';
var NO_LATIN_CHAR = /^[A-Za-z-0-9+@._]+$/;
var NO_LATIN_CHAR_ERROR = 'Sonderzeichen nicht erlaubt';
var DOMAINS = [
    'gmail.com',
    'googlemail.com',
    'yahoo.com',
    'yahoo.de',
    'gmx.de',
    't-online.de',
    'hotmail.com',
    'hotmail.de',
    'live.com',
    'live.de',
    'msn.com',
    'facebook.com',
    'outlook.com',
    'outlook.de',
    'gmx.net',
    'icloud.com',
    'me.com',
    'mac.com',
    'aol.com',
    'aol.de',
    'web.de',
    'freenet.de',
    'arcor.de',
    'email.de',
    'onlinehome.de',
    'alice-dsl.net',
];
var DEFAULT_DOMAINS = [
    'web.de',
    'gmx.de',
    'gmail.com',
    't-online.de',
    'yahoo.de',
    'gmx.net',
    'googlemail.com',
    'hotmail.de',
    'freenet.de',
    'hotmail.com',
];
var Container = styled.div(function (_a) {
    var containerStyle = _a.containerStyle;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    ", "\n  "], ["\n    position: relative;\n    ", "\n  "])), containerStyle);
});
var getAccountAndDomain = function (value) {
    var _a = value.split(AT_CHARACTER), userAccount = _a[0], partOfDomain = _a[1];
    return { userAccount: userAccount, partOfDomain: partOfDomain };
};
var EmailInput = function (_a) {
    var _b;
    var _c = _a.value, value = _c === void 0 ? '' : _c, onChange = _a.onChange, containerStyle = _a.containerStyle, props = __rest(_a, ["value", "onChange", "containerStyle"]);
    var inputRef = useRef(null);
    var _d = useState([]), autoCompletions = _d[0], setAutoCompletions = _d[1];
    var _e = useState(value), emailValue = _e[0], setEmailValue = _e[1];
    var _f = useState(false), latinCharError = _f[0], setLatinCharError = _f[1];
    var parentRef = useOutSideClick(function () { return setAutoCompletions([]); });
    var _g = useHover(), autoCompletionsRef = _g[0], isHovered = _g[1];
    var isAutoCompletionsMenuOpen = emailValue && emailValue.includes(AT_CHARACTER) && !isEmpty(autoCompletions);
    var inputError = props.error ? props.error : latinCharError ? NO_LATIN_CHAR_ERROR : '';
    var inputValidation = props.validation || latinCharError;
    var handleChange = useCallback(function (e) {
        var changeEventValue = e.target.value;
        if (onChange) {
            onChange(changeEventValue);
        }
        setEmailValue(changeEventValue);
        setLatinCharError(!NO_LATIN_CHAR.test(changeEventValue));
        if (changeEventValue.includes(AT_CHARACTER)) {
            var partOfDomain_1 = getAccountAndDomain(changeEventValue).partOfDomain;
            if (!partOfDomain_1) {
                setAutoCompletions(DEFAULT_DOMAINS);
            }
            else {
                setAutoCompletions(DOMAINS.filter(function (email) { return email !== partOfDomain_1 && email.startsWith(partOfDomain_1); }));
            }
        }
    }, [onChange]);
    var handleItemClick = function (item) {
        setAutoCompletions([]);
        var userAccount = getAccountAndDomain(emailValue).userAccount;
        var email = "" + userAccount + item;
        setEmailValue(email);
        if (onChange) {
            onChange(email);
        }
    };
    var handleKeyDown = function (e) {
        if (e.keyCode === TAB_KEY && isAutoCompletionsMenuOpen && isHovered) {
            e.preventDefault();
        }
        else {
            setAutoCompletions([]);
        }
    };
    return (React.createElement(Container, { "data-component": "EmailInput", containerStyle: containerStyle, ref: parentRef },
        React.createElement(Input, __assign({}, props, { value: emailValue, autoComplete: "off", ref: inputRef, onChange: handleChange, onKeyDown: handleKeyDown, validation: inputValidation, error: inputError })),
        React.createElement(AutoCompletions, { customRef: autoCompletionsRef, offset: (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight, inputValue: getAccountAndDomain(emailValue).partOfDomain, autoCompletions: autoCompletions, onItemClick: handleItemClick, prefix: AT_CHARACTER, isOpen: isAutoCompletionsMenuOpen })));
};
export default EmailInput;
var templateObject_1;
//# sourceMappingURL=EmailInput.js.map